import { render, staticRenderFns } from "./SubscriptionBox.vue?vue&type=template&id=a91a5f9e&scoped=true&"
import script from "./SubscriptionBox.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBox.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBox.vue?vue&type=style&index=0&id=a91a5f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91a5f9e",
  null
  
)

export default component.exports